/**
 * Scene photographs only. Every label, readout and control is real DOM
 * text in the components — never baked into these files.
 */
import hero1536 from '../assets/visuals/hero-scene-1536.webp';
import hero960 from '../assets/visuals/hero-scene-960.webp';
import hero640 from '../assets/visuals/hero-scene-640.webp';
import civil1536 from '../assets/visuals/civil3d-scene-1536.webp';
import civil960 from '../assets/visuals/civil3d-scene-960.webp';
import civil640 from '../assets/visuals/civil3d-scene-640.webp';
import viewRgb720 from '../assets/visuals/view-rgb-720.webp';
import viewRgb420 from '../assets/visuals/view-rgb-420.webp';
import viewDepth720 from '../assets/visuals/view-depth-720.webp';
import viewDepth420 from '../assets/visuals/view-depth-420.webp';
import viewCloud720 from '../assets/visuals/view-cloud-720.webp';
import viewCloud420 from '../assets/visuals/view-cloud-420.webp';
import viewMesh720 from '../assets/visuals/view-mesh-720.webp';
import viewMesh420 from '../assets/visuals/view-mesh-420.webp';
import domainBuilt720 from '../assets/visuals/domain-built-720.webp';
import domainBuilt480 from '../assets/visuals/domain-built-480.webp';
import domainRobotics720 from '../assets/visuals/domain-robotics-720.webp';
import domainRobotics480 from '../assets/visuals/domain-robotics-480.webp';
import domainIndustrial720 from '../assets/visuals/domain-industrial-720.webp';
import domainIndustrial480 from '../assets/visuals/domain-industrial-480.webp';
import domainInfra720 from '../assets/visuals/domain-infrastructure-720.webp';
import domainInfra480 from '../assets/visuals/domain-infrastructure-480.webp';

export const HERO_SCENE = {
  src: hero1536,
  srcSet: `${hero640} 640w, ${hero960} 960w, ${hero1536} 1536w`,
  sizes: '(max-width: 700px) 92vw, (max-width: 1100px) 88vw, 560px',
  alt: 'A LiDAR scanner reconstructing a modern office as a dense 3D point cloud.',
  width: 1536,
  height: 1024,
};

export const CIVIL3D_SCENE = {
  src: civil1536,
  srcSet: `${civil640} 640w, ${civil960} 960w, ${civil1536} 1536w`,
  sizes: '(max-width: 900px) 92vw, 640px',
  alt: 'civil3d reconstructing an apartment interior from a live spatial capture.',
  width: 1536,
  height: 1024,
};

export const CIVIL3D_VIEWS = {
  rgb: {
    id: 'rgb',
    label: 'RGB',
    src: viewRgb720,
    srcSet: `${viewRgb420} 420w, ${viewRgb720} 720w`,
    alt: 'RGB capture of the reconstructed apartment.',
  },
  depth: {
    id: 'depth',
    label: 'Depth',
    src: viewDepth720,
    srcSet: `${viewDepth420} 420w, ${viewDepth720} 720w`,
    alt: 'Depth view of the same capture.',
  },
  cloud: {
    id: 'cloud',
    label: 'Point cloud',
    src: viewCloud720,
    srcSet: `${viewCloud420} 420w, ${viewCloud720} 720w`,
    alt: 'Point-cloud view of the same capture.',
  },
  mesh: {
    id: 'mesh',
    label: 'Mesh',
    src: viewMesh720,
    srcSet: `${viewMesh420} 420w, ${viewMesh720} 720w`,
    alt: 'Mesh view of the same capture.',
  },
};

export const DOMAIN_VISUALS = {
  built: {
    src: domainBuilt720,
    srcSet: `${domainBuilt480} 480w, ${domainBuilt720} 720w`,
    alt: 'A modern building captured as a spatial model.',
  },
  robotics: {
    src: domainRobotics720,
    srcSet: `${domainRobotics480} 480w, ${domainRobotics720} 720w`,
    alt: 'A legged robot moving through an industrial site.',
  },
  industrial: {
    src: domainIndustrial720,
    srcSet: `${domainIndustrial480} 480w, ${domainIndustrial720} 720w`,
    alt: 'Industrial process equipment as a 3D reconstruction subject.',
  },
  infrastructure: {
    src: domainInfra720,
    srcSet: `${domainInfra480} 480w, ${domainInfra720} 720w`,
    alt: 'A bridge span captured as a measurable spatial record.',
  },
};

export const STACK_LAYERS = [
  { title: 'Sensor fusion', body: 'LiDAR, vision, IMU and depth, time-aligned.' },
  { title: 'Localization + mapping', body: 'Pose and a live map of the space.' },
  { title: '3D reconstruction', body: 'Persistent geometry of the real place.' },
  { title: 'Spatial understanding', body: 'Structure, semantics and measurable meaning.' },
  { title: 'Edge AI', body: 'On-device inference where the loop is live.' },
  { title: 'Applications', body: 'civil3d, robotics, industrial vision.' },
];
